import { render, staticRenderFns } from "./NewsArticle.vue?vue&type=template&id=701cb522&scoped=true&"
import script from "./NewsArticle.vue?vue&type=script&lang=ts&"
export * from "./NewsArticle.vue?vue&type=script&lang=ts&"
import style0 from "./NewsArticle.vue?vue&type=style&index=0&id=701cb522&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701cb522",
  null
  
)

export default component.exports